import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, GitBranchIcon, SparklesIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function MechanismSection() {
  return <section className="w-full px-5 py-16 md:py-24 bg-[#F5F0EA]" data-id="element-243">
      <div className="max-w-3xl mx-auto" data-id="element-244">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-semibold text-[#2C2825] mb-4 text-center" data-id="element-245">
          El sistema de 3 pasos que cambia las reglas
        </motion.h2>

        <motion.p {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.05
      }} className="text-[#2C2825]/70 text-[15px] md:text-base leading-relaxed text-center mb-14 max-w-2xl mx-auto" data-id="element-246">
          Mapa de Ojeras™ no es otro ebook de belleza. Es un sistema visual
          diseñado para que entiendas tu zona del contorno de ojos y actúes con
          precisión.
        </motion.p>

        <div className="space-y-6" data-id="element-247">
          {/* Step 1 */}
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.1
        }} className="bg-white rounded-xl p-6 md:p-8 border border-[#B8A99A]/15 flex gap-5" data-id="element-248">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4956A]/10 flex items-center justify-center" data-id="element-249">
              <SearchIcon className="w-5 h-5 text-[#C4956A]" data-id="element-250" />
            </div>
            <div data-id="element-251">
              <div className="flex items-baseline gap-3 mb-2" data-id="element-252">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#C4956A]" data-id="element-253">
                  Paso 1
                </span>
                <h3 className="text-lg font-semibold text-[#2C2825]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-254">
                  MAPA (3 min)
                </h3>
              </div>
              <p className="text-[#2C2825]/70 text-sm leading-relaxed" data-id="element-255">
                Haces el test visual guiado. Con fotos de referencia y preguntas
                sencillas, identificas tu tipo de ojera dominante (o
                combinación).
              </p>
            </div>
          </motion.div>

          {/* Step 2 */}
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.15
        }} className="bg-white rounded-xl p-6 md:p-8 border border-[#B8A99A]/15 flex gap-5" data-id="element-256">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4956A]/10 flex items-center justify-center" data-id="element-257">
              <GitBranchIcon className="w-5 h-5 text-[#C4956A]" data-id="element-258" />
            </div>
            <div data-id="element-259">
              <div className="flex items-baseline gap-3 mb-2" data-id="element-260">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#C4956A]" data-id="element-261">
                  Paso 2
                </span>
                <h3 className="text-lg font-semibold text-[#2C2825]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-262">
                  DECISIÓN
                </h3>
              </div>
              <p className="text-[#2C2825]/70 text-sm leading-relaxed" data-id="element-263">
                El árbol de decisión te lleva directamente a tu rutina
                personalizada. Sin leer 40 páginas. Sin adivinar.
              </p>
            </div>
          </motion.div>

          {/* Step 3 */}
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.2
        }} className="bg-white rounded-xl p-6 md:p-8 border border-[#B8A99A]/15 flex gap-5" data-id="element-264">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4956A]/10 flex items-center justify-center" data-id="element-265">
              <SparklesIcon className="w-5 h-5 text-[#C4956A]" data-id="element-266" />
            </div>
            <div data-id="element-267">
              <div className="flex items-baseline gap-3 mb-2" data-id="element-268">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#C4956A]" data-id="element-269">
                  Paso 3
                </span>
                <h3 className="text-lg font-semibold text-[#2C2825]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-270">
                  EJECUCIÓN
                </h3>
              </div>
              <p className="text-[#2C2825]/70 text-sm leading-relaxed" data-id="element-271">
                Aplicas tu rutina de mañana y noche (2 pasos) + 1 acción
                semanal. Y con la guía de corrección óptica, aprendes a
                disimular tus ojeras hoy mismo mientras la rutina trabaja.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}